/**
 * Shared Select options for authentication forms
 */

/**
 * AWS Region options for Amazon Bedrock authentication
 */
export const AWS_REGION_OPTIONS = [
  { label: 'US East (N. Virginia) - us-east-1', value: 'us-east-1' },
  { label: 'US East (Ohio) - us-east-2', value: 'us-east-2' },
  { label: 'US West (N. California) - us-west-1', value: 'us-west-1' },
  { label: 'US West (Oregon) - us-west-2', value: 'us-west-2' },
  { label: 'Europe (Ireland) - eu-west-1', value: 'eu-west-1' },
  { label: 'Europe (Frankfurt) - eu-central-1', value: 'eu-central-1' },
  {
    label: 'Asia Pacific (Singapore) - ap-southeast-1',
    value: 'ap-southeast-1'
  },
  { label: 'Asia Pacific (Sydney) - ap-southeast-2', value: 'ap-southeast-2' },
  { label: 'Asia Pacific (Tokyo) - ap-northeast-1', value: 'ap-northeast-1' }
];

/**
 * Vertex AI Location options for Google Cloud authentication
 */
export const VERTEX_AI_LOCATION_OPTIONS = [
  { label: 'Iowa (us-central1)', value: 'us-central1' },
  { label: 'South Carolina (us-east1)', value: 'us-east1' },
  { label: 'Northern Virginia (us-east4)', value: 'us-east4' },
  { label: 'Oregon (us-west1)', value: 'us-west1' },
  { label: 'Los Angeles (us-west2)', value: 'us-west2' },
  { label: 'Salt Lake City (us-west3)', value: 'us-west3' },
  { label: 'Las Vegas (us-west4)', value: 'us-west4' },
  {
    label: 'Montreal (northamerica-northeast1)',
    value: 'northamerica-northeast1'
  },
  {
    label: 'Toronto (northamerica-northeast2)',
    value: 'northamerica-northeast2'
  },
  { label: 'São Paulo (southamerica-east1)', value: 'southamerica-east1' },
  { label: 'Belgium (europe-west1)', value: 'europe-west1' },
  { label: 'London (europe-west2)', value: 'europe-west2' },
  { label: 'Frankfurt (europe-west3)', value: 'europe-west3' },
  { label: 'Netherlands (europe-west4)', value: 'europe-west4' },
  { label: 'Zurich (europe-west6)', value: 'europe-west6' },
  { label: 'Taiwan (asia-east1)', value: 'asia-east1' },
  { label: 'Hong Kong (asia-east2)', value: 'asia-east2' },
  { label: 'Tokyo (asia-northeast1)', value: 'asia-northeast1' },
  { label: 'Osaka (asia-northeast2)', value: 'asia-northeast2' },
  { label: 'Seoul (asia-northeast3)', value: 'asia-northeast3' },
  { label: 'Mumbai (asia-south1)', value: 'asia-south1' },
  { label: 'Singapore (asia-southeast1)', value: 'asia-southeast1' },
  { label: 'Jakarta (asia-southeast2)', value: 'asia-southeast2' },
  { label: 'Sydney (australia-southeast1)', value: 'australia-southeast1' },
  { label: 'Melbourne (australia-southeast2)', value: 'australia-southeast2' }
];
